import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmblemComponent } from './emblem/emblem.component';
import { NavbarComponent } from './navbar/navbar.component';
import { RouterModule } from '@angular/router';
import { AlertComponent } from './alert/alert.component';
import { FooterComponent } from './footer/footer.component'

@NgModule({
  declarations: [
    EmblemComponent,
    NavbarComponent,
    AlertComponent,
    FooterComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
  ],
  exports: [
    EmblemComponent,
    NavbarComponent,
    FooterComponent,
    AlertComponent
  ]
})
export class ComponentModule { }
